interface TaskTemplateValues {
  title?: string;
  priority?: number;
  default_due_days?: number;
}

interface ValidationErrors {
  title?: string;
  priority?: string;
  default_due_days?: string;
}

export const validateTaskTemplates = (values: TaskTemplateValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!values.title || values.title.trim() === "") {
    errors.title = "Title is required";
  }

  if (values.priority !== undefined && values.priority !== null && values.priority < 0) {
    errors.priority = "Priority must be 0 or greater";
  }

  if (values.default_due_days !== undefined && values.default_due_days !== null && values.default_due_days < 1) {
    errors.default_due_days = "Due days must be at least 1";
  }

  return errors;
};
